import SidebarNavAccordion from "@components/SidebarNavAccordion";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHasPermission } from "../../../../hooks/useHasPermission";
import { startUIShowModulesCount } from "../../../../redux/actions/administrador/ui/ui";
import { IconApp } from "../../../IconApp";
import { NavLinkApp } from "../../../NavLinkApp";

export const Modules_Reports = () => {
    const dispatch = useDispatch();
    const { hasPermission } = useHasPermission();
    const { color_text_menu_accordion } = useSelector((state) => state.config);

    const canShowAccordion = hasPermission([
        "CYCLE_STUDENTS_REPORT",
        "STUDENTS_BY_SCHEDULE_REPORT",
        "SCHOLARSHIPS_REPORT",
        "GRADE_UPLOAD_REPORT",
        "TEACHERS_BY_CYCLE_REPORT",
        "ORIGIN_SCHOOLS_REPORT",
        "ACADEMIC_STATUS_REPORT",
        "CLASS_SCHEDULES_REPORT",
        "ACADEMIC_RECORDS_BY_CURRICULUM",
        "VEHICLE_PLATES_REPORT",
        "GENERAL_AVERAGES_REPORT",
        "STUDENTS_ATTENDANCES_REPORT",
        "ATTENDANCES_REPORT",
        "CLASS_LOAD_REPORT",
        "INSCRIPTION_SUMMARY",
        "SUBJECT_HOURS_REPORT",
        "SUBJECT_AND_PAYMENTS_BY_STUDENTS_REPORT",
        "LANGUAGE_FOLLOW_UP",
        "GRADES_BY_SUBJECT_REPORT_MASSIVE",
    ]);

    useEffect(() => {
        if (canShowAccordion) {
            dispatch(startUIShowModulesCount("Modules_Reports"));
        }
    }, [canShowAccordion]);

    return (
        <div>
            {true && (
                <SidebarNavAccordion
                    title={"Reportes"}
                    itemLevel={0}
                    color={color_text_menu_accordion}
                    iconLeftClassName="fa-solid fa-files fa-xl"
                >
                    {hasPermission([
                        "CYCLE_STUDENTS_REPORT",
                        "ACADEMIC_RECORDS_BY_CURRICULUM",
                        "STUDENTS_BY_SCHEDULE_REPORT",
                        "STUDENTS_ATTENDANCES_REPORT",
                        "ACADEMIC_STATUS_REPORT",
                        "CLASS_SCHEDULES_REPORT",
                        "GRADE_UPLOAD_REPORT",
                        "GENERAL_AVERAGES_REPORT",
                        "INSCRIPTION_SUMMARY",
                        "LANGUAGE_FOLLOW_UP",
                        "GENERATIONAL_TABLE_REPORT",
                        "SCHOLARSHIPS_REPORT",
                        "GRADES_BY_SUBJECT_REPORT_MASSIVE",
                    ]) && (
                        <SidebarNavAccordion
                            title={"Alumnos"}
                            itemLevel={1}
                            color={color_text_menu_accordion}
                            iconLeftClassName={
                                "fa-solid fa-user-graduate fa-xl me-2"
                            }
                        >
                            {hasPermission("CYCLE_STUDENTS_REPORT") && (
                                <NavLinkApp
                                    name="Alumnos por ciclos"
                                    to="/app/cycle/students/report"
                                    icon={
                                        <IconApp iconClassName="fas fa-solid fa-screen-users c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission(
                                "ACADEMIC_RECORDS_BY_CURRICULUM"
                            ) && (
                                <NavLinkApp
                                    name="Alumnos por Oferta"
                                    to="/app/students/report/academic_records/by/curriculum"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-arrows-spin c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission("STUDENTS_BY_SCHEDULE_REPORT") && (
                                <NavLinkApp
                                    name="Alumnos por horario"
                                    to="/app/students-by-schedule/report"
                                    icon={
                                        <IconApp iconClassName="fas fa-solid fa-calendar-circle-user c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission("STUDENTS_ATTENDANCES_REPORT") && (
                                <NavLinkApp
                                    name="Asistencias alumnos"
                                    to="/app/students/attendance/report"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-person-walking c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission("SCHOLARSHIPS_REPORT") && (
                                <NavLinkApp
                                    name="Becas"
                                    to="/app/school/scholarships/report"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-backpack c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}

                            {hasPermission("GRADE_UPLOAD_REPORT") && (
                                <NavLinkApp
                                    name="Carga de calificaciones"
                                    to="/app/school/grade/report"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-file-chart-pie c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}

                            {hasPermission(
                                "GRADES_BY_SUBJECT_REPORT_MASSIVE"
                            ) && (
                                <NavLinkApp
                                    name="Calificaciones por materia"
                                    to="/app/school/grade/report/by/subject/massive"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-clipboard-user c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}

                            {hasPermission("GENERAL_AVERAGES_REPORT") && (
                                <NavLinkApp
                                    name="Datos académicos"
                                    to="/app/school/grade/report/averages/general"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-ranking-star c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}

                            {hasPermission("ACADEMIC_STATUS_REPORT") && (
                                <NavLinkApp
                                    name="Estatus académico"
                                    to="/app/students/academic/status"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-wave-pulse c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}

                            {hasPermission(["INSCRIPTION_SUMMARY"]) && (
                                <NavLinkApp
                                    name="Resumen de inscripción"
                                    to="/app/inscriptionsummary"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-file-chart-pie c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission(["LANGUAGE_FOLLOW_UP"]) && (
                                <NavLinkApp
                                    name="Seguimiento de idiomas"
                                    to="/app/language/follow-up"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-earth-americas c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission("GENERATIONAL_TABLE_REPORT") && (
                                <NavLinkApp
                                    name="Tabla generacional"
                                    to="/app/students/report/generational-table"
                                    icon={
                                        <IconApp iconClassName="fas fa-chart-area c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}

                            {hasPermission([
                                "CLASS_LOAD_REPORT",
                                "CLASS_SCHEDULES_REPORT",
                                "SUBJECT_HOURS_REPORT",
                                "SUBJECT_AND_PAYMENTS_BY_STUDENTS_REPORT",
                            ]) && (
                                <SidebarNavAccordion
                                    title={"Horarios"}
                                    itemLevel={2}
                                    color={color_text_menu_accordion}
                                    iconLeftClassName={
                                        "fa-solid fa-server fa-xl me-2"
                                    }
                                >
                                    {hasPermission("CLASS_LOAD_REPORT") && (
                                        <NavLinkApp
                                            name="Carga horaria"
                                            to="/app/class-load/report"
                                            icon={
                                                <IconApp iconClassName="fas fa-regular fa-calendar-exclamation c-sidebar-nav-icon"></IconApp>
                                            }
                                        />
                                    )}

                                    {hasPermission(
                                        "CLASS_SCHEDULES_REPORT"
                                    ) && (
                                        <NavLinkApp
                                            name="Horarios por edificio"
                                            to="/app/class-schedules/report"
                                            icon={
                                                <IconApp iconClassName="fas fa-building c-sidebar-nav-icon"></IconApp>
                                            }
                                        />
                                    )}
                                    {hasPermission("SUBJECT_HOURS_REPORT") && (
                                        <NavLinkApp
                                            name="Horas por materia"
                                            to="/app/subject-hours/report"
                                            icon={
                                                <IconApp iconClassName="fas fa-regular fa-calendar-clock c-sidebar-nav-icon"></IconApp>
                                            }
                                        />
                                    )}
                                    {hasPermission(
                                        "SUBJECT_AND_PAYMENTS_BY_STUDENTS_REPORT"
                                    ) && (
                                        <NavLinkApp
                                            name="Materias y pagos de alumnos"
                                            to="/app/subjects-and-payments/by/students/report"
                                            icon={
                                                <IconApp iconClassName="fas fa-regular fa-magnifying-glass-dollar c-sidebar-nav-icon"></IconApp>
                                            }
                                        />
                                    )}
                                </SidebarNavAccordion>
                            )}
                        </SidebarNavAccordion>
                    )}

                    {hasPermission([
                        "DEBTS_BY_MONTH",
                        "PAST_DUE_PORTFOLIO",
                        "SERVICES_BY_CONCEPT_REPORT",
                    ]) && (
                        <SidebarNavAccordion
                            title={"Cobranza"}
                            itemLevel={1}
                            color={color_text_menu_accordion}
                            iconLeftClassName={
                                "fa-solid fa-sack-dollar fa-xl me-2"
                            }
                        >
                            {hasPermission("DEBTS_BY_MONTH") && (
                                <NavLinkApp
                                    name="Adeudos por mes"
                                    to="/app/students/report/debts-by-month"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-circle-dollar-to-slot c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission(["PAST_DUE_PORTFOLIO"]) && (
                                <NavLinkApp
                                    name="Estados de cuenta"
                                    to="/app/past-due-portfolio"
                                    icon={
                                        <IconApp iconClassName="fa-solid fa-business-time c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission(["SERVICES_BY_CONCEPT_REPORT"]) && (
                                <NavLinkApp
                                    name="Servicios por concepto"
                                    to="/app/services-by-concept"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-memo-circle-check c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                        </SidebarNavAccordion>
                    )}

                    {hasPermission([
                        "ATTENDANCES_REPORT",
                        "TEACHERS_BY_CYCLE_REPORT",
                        "TEACHERS_ESTIMATED_PAYROLL_REPORT",
                        "TEACHERS_PERFORMANCE",
                    ]) && (
                        <SidebarNavAccordion
                            title={"Docentes"}
                            itemLevel={1}
                            color={color_text_menu_accordion}
                            iconLeftClassName={
                                "fa-solid fa-person-chalkboard fa-xl me-2"
                            }
                        >
                            {hasPermission("ATTENDANCES_REPORT") && (
                                <NavLinkApp
                                    name="Asistencias docentes"
                                    to="/app/teacher/attendance/report"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-clipboard-user c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission("TEACHERS_BY_CYCLE_REPORT") && (
                                <NavLinkApp
                                    name="Docentes por ciclo"
                                    to="/app/teachers/by/cycle"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-person-chalkboard c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission(["TEACHERS_PERFORMANCE"]) && (
                                <NavLinkApp
                                    name="Desempeño docentes"
                                    to="/app/teachers-performance"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-star c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}

                            {hasPermission(
                                "TEACHERS_ESTIMATED_PAYROLL_REPORT"
                            ) && (
                                <NavLinkApp
                                    name="Nómina estimada docentes"
                                    to="/app/teachers/report/estimated-payroll"
                                    icon={
                                        <IconApp iconClassName="fas fa-chalkboard-user c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                        </SidebarNavAccordion>
                    )}

                    {hasPermission([
                        "ORIGIN_SCHOOLS_REPORT",
                        "VEHICLE_PLATES_REPORT",
                    ]) && (
                        <SidebarNavAccordion
                            title={"Administrativos"}
                            itemLevel={1}
                            color={color_text_menu_accordion}
                            iconLeftClassName={
                                "fa-solid fa-briefcase fa-xl me-2"
                            }
                        >
                            {hasPermission("ORIGIN_SCHOOLS_REPORT") && (
                                <NavLinkApp
                                    name="Escuelas de procedencia"
                                    to="/app/students/report/origin-schools"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-school c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission("VEHICLE_PLATES_REPORT") && (
                                <NavLinkApp
                                    name="Placas vehiculares"
                                    to="/app/vehicle-plates/report"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-cars c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                        </SidebarNavAccordion>
                    )}
                </SidebarNavAccordion>
            )}
        </div>
    );
};
